import view from "../../views/user.js";
import { _user, _handler, TimeAgoUpdater } from "../classes/index.classes";
import KTAPI from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";
import { errorMsg } from "./offscreen.controller";

var loading = false;
var tempdata = {};
var ratingHistoryChartA = null;
var ratingHistoryChartB = null;
let user = {
    render: (data) => {
        return view;
    },
    after_render: async (data) => {        
                
        if(data.tab == undefined) data.tab = "overview";
        if(data.tab == 'stats' && data.subtab == undefined) data.subtab = "overall";


        //let cmid = router.getCurrentLocation().route.name.replace("user/","");
        //console.log(data);
        if(data.rerender)
        {    let me = false;
            if(data.communityid == _user.me.communityid) me = true;
            
            data.me = me;
            let userinfo = data;

            let fstatus;
            if(!data.me && _user.authed)
            {
                fstatus = await KTAPI.getFriendStatus({who: data.steamid});
                //console.log(fstatus);
                if(fstatus.message != 'error')
                {
                    data.friendStatus = fstatus[0].friendsStatus;
                }
            }

            renderHeaderProfile(userinfo);
            tempdata = userinfo;
        }
        
        $(`.profile-nav-tabs a[tab="${data.tab}"]`).tab('show');
        if(data.tab == 'stats') $(`.profile-stats-pill[tab="${data.subtab}"]`).tab('show');
        //renderTab("overview", tempdata);
        

    },
    root: false, 
    rerender: true,
    where: '#kt_content'
};


$(document).ready(function(){
    $(document).on("shown.bs.tab", "a.profile-pill[data-bs-toggle=tab]", function (e) {
        //console.log($(this).attr("href"));
        renderTab($(this).attr("tab"), tempdata);
    });

    $(document).on("shown.bs.tab", "a.profile-stats-pill[data-bs-toggle=pill]", function (e) {
        //console.log($(this).attr("href"));
        //alert($(this).attr("tab"));
        renderStatsTab($(this).attr("tab"), tempdata);
    });
});


function renderHeaderProfile(data)
{
    renderBan(data);
    
    $('.profile-nav-tabs a[data-bs-toggle="tab"]').each(function(index, element) {
        $(this).attr("href",`user/${data.communityid}/${$(this).attr("tab")}`);
    });
    $('a.profile-stats-pill[data-bs-toggle=pill]').each(function(index, element) {
        $(this).attr("href",`user/${data.communityid}/stats/${$(this).attr("tab")}`);
    });
    $('a.profile-quicklink').each(function(index, element) {
        $(this).attr("href",`user/${data.communityid}/${$(this).attr("tab")}`);
    });

    $(".profile-user-avatar").attr("src", data.avatar);
    $(".profile-user-nick").text(data.nickname);
    $(".profile-flag").attr("src", `assets/media/flags/${data.countrycode.toLowerCase()}.gif`);
    $(".profile-country").text(data.country);
    $(".profile-steamid").text(data.steamid);
    $(".profile-online-badge").addClass(data.connected ? "bg-success" : "bg-gray-400").attr("steamid", data.steamid);
    $(".profile-user-steam-link").attr("href", `https://steamcommunity.com/profiles/${data.communityid}/`).attr("target", "_blank").attr("title", "Steam Profile: "+data.steamid).attr("data-navigo", "");
    $(".profile-user-steam-link").find("[data-toggle=tooltip]").tooltip();

    $(".profile-created").text(moment.unix(parseInt(data.created)+hostStampDif).locale(localStorage.getItem("i18nextLng")).format("MMMM DD, YYYY"));
    $(".profile-lastlogin").text(moment.unix(parseInt(data.lastlogin)+hostStampDif).locale(localStorage.getItem("i18nextLng")).fromNow());

    router.updatePageLinks();
    
    if(_user.authed == true && !data.me)
    {
        let btn = ``;
        if(data.friendStatus == 0)
        {
            btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary py-2 px-4 fs-8 fs-bolder text-primary friend-add" data-commid="${data.communityid}"><i class="fad fa-user-plus"></i> <span class="">Add friend</span></button>`;
        }
        if(data.friendStatus == 1)
        {
            
            btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-info btn-active-light-info py-2 px-4 fs-8 fs-bolder text-info cursor-default friend-pending" style="cursor:default !important"><i class="fad fa-user-clock"></i> <span class="">Pending response</span></button>`;
        }
        if(data.friendStatus == 2)
        {
            btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark py-2 px-4 fs-8 fs-bolder text-dark cursor-default friend-requested"  style="cursor:default !important"><i class="fad fa-user-clock"></i> <span class="">Request sent</span></button>`;
        }
        if(data.friendStatus == 3)
        {
            btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-success btn-active-light-success py-2 px-4 fs-8 fs-bolder text-success cursor-default friend-friend" style="cursor:default !important"><i class="fad fa-user-check"></i> <span class="">Friends</span></button>`;
        }

        
        btn = $(btn);
        btn.localize();

        $(".profile-actions").html(btn);        
        router.updatePageLinks();
    }
    
}

async function renderBan(data)
{
    let res = await KTAPI.getUserBans({steamid: data.steamid, banreq: true});
    if(res.message !== undefined && res.message == 'error') return;
    let bans = res.data.results;
    if(bans.length > 0)
    {
        let ban = bans[0];
        let html = `
        <!--<div class="card card-flush w-100 bgi-position-x-end bgi-position-y-top mb-6" style="background-image:url('assets/media/misc/bg_ban.png');">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-50px me-5">
                        <span class="symbol-label bg-light-danger">
                            <i class="fa fa-user-slash text-danger fs-1"></i>
                        </span>
                    </div>
                    
                    <div class="d-flex justify-content-start flex-column">
                        <span class="text-dark fw-bold fs-5"><span>This user has been</span> <span class="${parseInt(ban.duration) == 0 ? 'text-danger' : 'text-primary'}">${parseInt(ban.duration) == 0 ? 'permanently' : 'temporally'}</span> <span>banned</span></span>
                        <div class="d-flex flex-row justify-content-start">
                            <span class="badge badge-sm bg-gray-900 text-black fs-7"><span>Reason</span>: <span>${ban.reason}</span></span>
                        </div>
                    </div>
                </div>
            </div>            
        </div>-->

        <div class="alert border bg-light-danger border-danger d-flex align-items-center p-5 bg-light-danger bgi-position-x-end bgi-position-y-top mb-6" role="alert" style="background-image:url('assets/media/misc/bg_ban.png');">
            <i class="fad fa-user-slash fs-1 text-danger me-4"><span class="path1"></span><span class="path2"></span></i>
            
            <div class="d-flex flex-column">                
                <span class="text-dark fw-bold"><span>This user has been</span> <span class="${parseInt(ban.duration) == 0 ? 'text-danger' : 'text-primary'}">${parseInt(ban.duration) == 0 ? 'permanently' : 'temporally'}</span> <span>banned</span></span>
                <div class="d-flex flex-row justify-content-start">
                    <span class="badge badge-sm bg-gray-900 text-black fs-7"><span>Reason</span>: <span>${ban.reason}</span></span>
                </div>
            </div>                                                    
        </div>
        `;
        html = $(html);
        html.localize();
        $(".profile-ban").html("").append(html);
    }
    
}

async function renderTab(tab, data)
{    
    if(tab == 'overview')
    {
        let html = ``;
        
        $(".overview-rating").text(data.stats.rating);

        $(".overview-rating").attr("data-kt-countup-value", data.stats.rating);
        $(".overview-kdr").attr("data-kt-countup-value", (data.stats.kills/(data.stats.deaths == 0 ? 1 : data.stats.deaths)).toFixed(2));
        $(".overview-kpr").attr("data-kt-countup-value", (data.stats.kills/(data.stats.rounds == 0 ? 1 : data.stats.rounds)).toFixed(2));
        $(".overview-adr").attr("data-kt-countup-value", (data.stats.damage/(data.stats.rounds == 0 ? 1 : data.stats.rounds)).toFixed(2));
        $(".overview-hsp").attr("data-kt-countup-value", (data.stats.hs*100/(data.stats.deaths == 0 ? 1 : data.stats.deaths)).toFixed(2));

        if(data.stats.rank == null) data.stats.rank = 0;
        if(data.stats.rank_country == null) data.stats.rank_country = 0;

        $(".overview-global-ranking").attr("data-kt-countup-value", data.stats.rank);
        $(".overview-country-ranking").attr("data-kt-countup-value", data.stats.rank_country);
        $(".overview-country-ranking-code").text(data.countrycode == '' ? data.stats.flag : data.countrycode.toUpperCase());

        KTApp.initCountUp();
        KTApp.initCountUpTabs();

        let rnk = getEloLevel(data.stats.rating, data.stats.rd);
        $(".overview-rank-img").attr("src", `assets/media/ranks/rank_${rnk.level}.png`);
        $(".overview-rank-level").text(rnk.level);
        $(".overview-rating-next").text(rnk.next);

        $(".overview-progress").css("width", `${(data.stats.rating - rnk.prev)*100/(rnk.next - rnk.prev)}%`);
        $(".overview-progress").attr("aria-valuenow", (data.stats.rating - rnk.prev)*100/(rnk.next - rnk.prev));

        let m = data.stats.matches_win + data.stats.matches_lose;
        $(".overview-matches").text(data.stats.matches);
        $(".overview-matches-won").text(data.stats.matches_win);
        $(".overview-matches-lose").text(data.stats.matches_lose);
        $(".overview-progress-won").css("width", `${(data.stats.matches_win * 100 / (m == 0 ? 1 : m)).toFixed(0)}%`);
        $(".overview-progress-lose").css("width", `${(data.stats.matches_lose * 100 / (m == 0 ? 1 : m)).toFixed(0)}%`);
        $(".overview-matches-won-percent").text((data.stats.matches_win * 100 / (m == 0 ? 1 : m)).toFixed(0)+"%");
        $(".overview-matches-lose-percent").text((data.stats.matches_lose * 100 / (m == 0 ? 1 : m)).toFixed(0)+"%");


        let res_visitors = await KTAPI.getUserVisits(data.steamid);
        $(".profile-views").text(data.visits+1);
        if(res_visitors.message == 'done' && res_visitors.visits.length)
        {            
            
            let visitors = [];
            res_visitors.visits.map(v => {
                let visitor = `
                <div class="d-flex flex-stack px-4 py-3 bg-state-white bg-state-opacity-5 rounded">                    
                    <div class="d-flex align-items-center w-100">                        
                        <div class="symbol symbol-35px popover-profile" data-steamid="${v.visitor.steamid}">
                            <img src="${v.visitor.avatar === undefined || v.visitor.avatar == '' ? 'assets/media/avatars/default.jpg' : v.visitor.avatar}" class="" alt="">
                        </div>
                        
                        <div class="ms-4 text-truncate fs-7">
                            <a href="user/${v.visitor.communityid}" data-navigo class="d-flex align-items-center fw-bold text-gray-800 text-hover-white">
                            <img class="me-2 pflag" height="12" width="18" src="assets/media/flags/${v.visitor.countrycode.toLowerCase()}.gif" data-toggle="tooltip" title="${v.visitor.city} ${v.visitor.country}"/><span class="fnick text-truncate" style="min-width:0;"></span>
                            </a>
                            <div class="fw-semibold text-muted">
                                <span class="timer-${v.visitor.communityid} text-truncate" moment-timestamp="${parseInt(parseInt(v.visitedAt))+hostStampDif}" data-toggle="tooltip" title="" style="min-width:0;"></span>
                            </div>
                        </div>
                    </div>
                </div>
                `;
                visitor = $(visitor);
                visitor.find(".fnick").text(v.visitor.nickname);

                new TimeAgoUpdater(visitor.find(".timer-"+v.visitor.communityid));
                visitor.localize();
                visitor.find("[data-toggle='tooltip']").tooltip();
                visitor.find("[data-toggle='tooltip']").attr("title", "");

                visitors.push(visitor);
            });

            $(".profile-tab-overview-visitors-none").addClass("d-none");
            $(".profile-tab-overview-visitors").html("").append(visitors);
        }
        router.updatePageLinks();
        


        let resf = await KTAPI.getFriends({id: data.me ? _user.me.communityid : data.communityid, paged: true, page: 1, limit: 20});
        if(resf.message !== undefined && resf.message == 'error') return;

        if(resf.totalDocs > 0)
        {
            let flist = [];
            resf.docs.map(r => {
                let f = `
                    


                    <div class="d-flex flex-stack px-4 py-3 bg-state-white bg-state-opacity-5 rounded">                    
                        <div class="d-flex align-items-center w-100">                        
                            <div class="symbol symbol-35px popover-profile" data-steamid="${r.steamid}">
                                <img src="${r.avatar === undefined || r.avatar == '' ? 'assets/media/avatars/default.jpg' : r.avatar}" class="" alt="">
                            </div>
                            
                            <div class="ms-4 text-truncate fs-7">
                                <a href="user/${r.communityid}" data-navigo class="d-flex align-items-center fw-bold text-gray-800 text-hover-white">
                                <img class="me-2 pflag" height="12" width="18" src="assets/media/flags/${r.countrycode.toLowerCase()}.gif" data-toggle="tooltip" title="${r.city} ${r.country}"/><span class="fnick text-truncate" style="min-width:0;"></span>
                                </a>
                                <div class="fw-semibold text-muted">
                                    <a href="https://steamcommunity.com/profiles/${r.communityid}/" target="_blank" class="fw-semibold text-truncate text-muted text-hover-gray-700" style="min-width:0;">${r.steamid}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                f = $(f);
                f.find(".fnick").text(r.nickname);
                f.find("[data-toggle='tooltip']").tooltip();
                flist.push(f);
                
            });
            
            $(".profile-tab-overview-flist").html("").append(flist);
        }
        else
        {   
            $(".profile-tab-overview-flist").html("")
            $(".profile-tab-overview-flist").html(`
                <div class="text-center">
                    <!--begin::Icon-->
                    <div class="pt-15 pb-6">
                        <i class="fad fa-user-friends fs-3x text-primary opacity-75"></i>
                    </div>
                    <!--end::Icon-->
                    <!--begin::Message-->
                    <div class="fw-bold pb-15">
                        <h3 class="text-gray-600 fs-5 mb-2">No friends found</h3>
                        <div class="text-muted fs-7">Invite some friends</div>
                    </div>
                    <!--end::Message-->
                </div>
            `);
            $(".profile-tab-overview-flist").localize();
        }


        let ms = await KTAPI.getPlayerMatches({steamid: data.steamid, paged: true, page: 1, limit: 5});
        //console.log(ms);

        let s = [];
        if(ms.docs !== undefined && ms.totalDocs > 0)
        {            
            ms.docs.map(mid => {
                //console.log(mid);
                if(mid.stats === undefined) return;
                let temp = `<a href="match/${mid.matchid}" data-navigo class="d-block text-reset text-decoration-none mb-4">
                    <div class="card card-flush cursor-pointer" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${mid.map}.jpg');background-color:#1b1b1b;">
                        <div class="card-body">
                            <div class="d-flex flex-column">                                               
                                <div class="d-flex flex-wrap align-items-center justify-content-center">
                                    <div class="d-flex flex-column text-center flex-grow-0 flex-shrink-1 ms-0 me-6 min-w-125px" style="flex-basis: 0%;">
                                        
                                        <span class="badge badge-sm badge-dark bg-transparent border border-primary flex-shrink-0 align-self-center text-primary fs-small">${mid.map}</span>
                                    </div>
                                    <div class="d-flex flex-column text-center flex-grow-0 flex-shrink-1 mx-6" style="flex-basis: 0%;">
                                        <span class="badge badge-sm badge-success flex-shrink-0 align-self-center text-gray-100">PUG</span>
                                        <div class="d-flex justify-content-around align-items-center text-white fs-1">
                                            <span class="">${mid.match.scoreT}</span><span class="">:</span><span class="">${mid.match.scoreCT}</span>
                                        </div>                                                        
                                    </div>
                                    <div class="d-flex flex-column text-center flex-grow-0 flex-shrink-1 mx-6" style="flex-basis: 0%;">
                                        <div class="m-0 text-start">
                                            <span class="fw-semibold text-gray-800 d-block fs-7" data-i18n="stats.result">Result</span>
                                            <span class="fw-bold text-gray-800 fs-6">${mid.result == 1 ? `<span class="text-success text-nowrap"><i class="fad fa-trophy-alt top-trophy-1 me-2 text-success"></i><span>WIN</span></span>`: `<span class="text-danger text-nowrap"><span>LOSE</span></span>`}</span>
                                        </div>
                                    </div>
                                    <div class="d-flex text-center flex-grow-1 flex-shrink-1 ms-6 me-0" style="flex-basis: 0%;">
                                        <div class="d-flex flex-wrap w-100 justify-content-around">
                                            <div class="text-start text-nowrap p-1">
                                                <div class="fw-semibold text-gray-600 d-block fs-8" data-toggle="tooltip" title="" data-i18n="[title]stats.kda;[data-bs-original-title]stats.kda">K / D / A</div>
                                                <div class="text-white fs-6">${mid.stats.kills} / ${mid.stats.deaths} / ${mid.stats.assists}</div>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap w-100 justify-content-around">
                                            <div class="text-start p-1">
                                                <div class="fw-semibold text-gray-600 d-block fs-8" data-i18n="[title]stats.tkdr;[data-bs-original-title]stats.tkdr">KDR</div>
                                                <div class="text-white fs-6">${(mid.stats.kills/(mid.stats.deaths == 0 ? 1 : mid.stats.deaths)).toFixed(2)}</div>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap w-100 justify-content-around">
                                            <div class="text-start p-1">
                                                <div class="fw-semibold text-gray-600 d-block fs-8" data-i18n="[title]stats.tadr;[data-bs-original-title]stats.tadr">ADR</div>
                                                <div class="text-white fs-6">${(mid.stats.damage/(mid.stats.rounds == 0 ? 1 : mid.stats.rounds)).toFixed(2)}</div>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap w-100 justify-content-around">
                                            <div class="text-start p-1">
                                                <div class="fw-semibold text-gray-600 d-block fs-8" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.hsp">HSP</div>
                                                <div class="text-white fs-6">${(mid.stats.hs*100/(mid.stats.kills == 0 ? 1 : mid.stats.kills)).toFixed(2)}%</div>
                                            </div>
                                        </div>
                                    </div>                                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </a>`

                temp = $(temp);
                temp.localize();
                s.push(temp);
            });
            $(".overview-match-list").html("").append(s);
            await router.updatePageLinks();
        }
        else
        {
            $(".overview-match-list").html("");
            $(".overview-match-list").html(`
                <div class="text-center">
                    <!--begin::Icon-->
                    <div class="pt-15 pb-6">
                        <i class="fad fa-swords fs-3x text-primary opacity-75"></i>
                    </div>
                    <!--end::Icon-->
                    <!--begin::Message-->
                    <div class="fw-bold pb-15">
                        <h3 class="text-gray-600 fs-5 mb-2" data-i18n="user.no_matches">No matches found</h3>
                        <div class="text-muted fs-7" data-i18n="user.no_matches_msg">Need to play some matches</div>
                    </div>
                    <!--end::Message-->
                </div>
            `);
            $(".overview-match-list").localize();

        }

        

    }

    if(tab == 'matches')
    {
        //console.log(data);
        $(".table-matches-body").html("").data("matches-page",1);
        $("#profile-matches-loader").removeClass("d-none");
        $(".table-matches-body").data("matches-total-results",0);
        $(".table-matches-body").data("matches-total-pages",0);
        $(".table-matches-body").data("matches-has-next",0);
        $(".table-matches-body").data("matches-next-page",0);

        let page = 1;
        loading = false;
        
        let res = await KTAPI.getPlayerMatches({steamid: data.steamid, paged: true, page, limit: 15});
        $(".table-matches-body").data("matches-total-results",res.totalDocs || 0);
        $(".table-matches-body").data("matches-total-pages",res.totalPages || 0);
        $(".table-matches-body").data("matches-has-next",res.hasNextPage || 0);
        $(".table-matches-body").data("matches-next-page",res.nextPage || 0);
        
        renderPlayerMatchesTable(res);
        $("#profile-matches-loader").addClass("d-none");

        
    }

    if(tab == 'friends')
    {
        
        //console.log(res);
        //console.log(data);
        $(".profile-friends-list").html("").data("friends-page",1);
        $("#profile-friends-loader").removeClass("d-none");
        $(".profile-friends-list").data("friends-total-results",0);
        $(".profile-friends-list").data("friends-total-pages",0);
        $(".profile-friends-list").data("friends-has-next",0);
        $(".profile-friends-list").data("friends-next-page",0);

        let page = 1;
        loading = false;
        let res = await KTAPI.getFriendsWithStats({id: tempdata.communityid, paged: true, page, limit: 10, requester: !_user.authed ? '' : _user.me._id});
        
        $(".profile-friends-list").data("friends-total-results",res.totalDocs || 0);
        $(".profile-friends-list").data("friends-total-pages",res.totalPages || 0);
        $(".profile-friends-list").data("friends-has-next",res.hasNextPage || 0);
        $(".profile-friends-list").data("friends-next-page",res.nextPage || 0);
        
        renderPlayerFriendsTable(res);
        $("#profile-friends-loader").addClass("d-none");
        router.updatePageLinks();

    }

    if(tab == 'stats')
    {
        //renderStatsTab("overall", tempdata);
        //renderStatsTab(data.subtab, data);
    }

    if(tab == 'bans')
    {
        let res = await KTAPI.getUserBans({steamid: data.steamid});
        
        if(res.message !== undefined && res.message == 'error') return;
        let bans = res.data.results;

        if(bans.length == 0)
        {
            $(".user-nobans").removeClass("d-none");
        }
        else
        {
            $(".user-nobans").addClass("d-none");
            /*let bans = [];
            res.results.map(b => {
                let ban = `
                    <div class="d-flex align-items-center mb-7">
                        <!--begin::Avatar-->
                        <div class="symbol symbol-50px me-5">
                            <img src="${b.avatar === undefined || b.avatar == '' ? 'assets/media/avatars/default.jpg' : b.avatar}" class="" alt="">
                        </div>
                        <!--end::Avatar-->                    
                        <!--begin::Text-->
                        <div class="w-100 overflow-hidden text-truncate">
                            <a href="user/${b.communityid}" data-navigo class="text-dark fw-bold fs-6 fnick text-truncate"></a>
                            <a href="https://steamcommunity.com/profiles/${b.communityid}/" target="_blank"><span class="text-muted d-block fw-bold text-truncate">${b.steamid}</span></a>
                        </div>
                        <!--end::Text-->                
                    </div>
                `;

                ban = $(ban);
                ban.find(".fnick").text(b.nickname);
                bans.push(ban);
            });

            $(".user-bans").html("").append(bans);*/
            let html = [];
            bans.map(b => {
                let ban = `
                    <tr style="background-color:#1b1b1b;">
                        <td class="ps-4 rounded-start text-info">${b.reason}</td>
                        <td class="fnick fw-normal"></td>
                        <td class="text-gray-800 fw-normal" data-i18n="example.datec" data-i18n-options='{"timestamp":"${parseInt(b.createdAt)+hostStampDif}"}'></td>
                        <td class="pe-4 rounded-end text-primary">${parseInt(b.expired) == 1 ? 'Expired' : (parseInt(b.duration) == 0 ? 'Permanent' : moment.unix(parseInt(b.duration)*1000).locale(localStorage.getItem("i18nextLng")).format("HH:mm:ss"))}</td>
                    </tr>
                    `;
                ban = $(ban);   
                ban.find(".fnick").text(b.nick);
                ban.localize();
                html.push(ban);
            });

            $(".table-bans-body").html("").append(html);

        }
    }
    $("body").localize();
}

async function renderStatsTab(tab, data){
    if(tab == 'overall')
    {
        //tables
        let content = /* html */ `<tr class="position-relative cursor-pointer fs-7" style="background-color: #1b1b1b">
            <td class="ps-4 text-start" style="border-bottom-left-radius: 0.475rem">${data.stats.kills}</td>
            <td class="text-center">${data.stats.assists}</td>
            <td class="text-center">${data.stats.deaths}</td>
            <td class="text-center">${data.stats.hs}</td>
            <td class="text-center">${data.stats.suicides}</td>
            <td class="text-center border border-start-0 border-top-0 border-bottom-0">${data.stats.tks}</td>
            <td class="text-center">${((data.stats.kills/(data.stats.deaths == 0 ? 1 : data.stats.deaths))).toFixed(2)}</td>
            <td class="text-center">${((data.stats.kills/(data.stats.rounds == 0 ? 1 : data.stats.rounds))).toFixed(2)}</td>
            <td class="text-center">${((data.stats.assists/(data.stats.kills == 0 ? 1 : data.stats.kills))).toFixed(2)}</td>
            <td class="text-center">${(data.stats.hs*100/(data.stats.kills == 0 ? 1 : data.stats.kills)).toFixed(2)}%</td>
            <td class="pe-4 text-end" style="border-bottom-right-radius: 0.475rem">${(data.stats.hs/(data.stats.kills == 0 ? 1 : data.stats.kills)).toFixed(2)}</td>
        </tr>`;

        $(".profile-stats-table-basic").html("").append(content);

        content = /* html */ `<tr class="position-relative cursor-pointer fs-7" style="background-color: #1b1b1b">
            <td class="ps-4 text-start" style="border-bottom-left-radius: 0.475rem">${data.stats.bombs_planted}</td>
            <td class="text-center">${data.stats.bombs_defused}</td>
            <td class="text-center">${data.stats.bombs_exploded}</td>
            <td class="text-center">${data.stats.bombsite_a}</td>
            <td class="text-center border border-start-0 border-top-0 border-bottom-0">${data.stats.bombsite_b}</td>
            <td class="text-center">${(data.stats.bombs_planted/(data.stats.matches == 0 ? 1 : data.stats.matches)).toFixed(2)}</td>
            <td class="text-center">${(data.stats.bombs_defused/(data.stats.matches == 0 ? 1 : data.stats.matches)).toFixed(2)}</td>
            <td class="pe-4 text-end" style="border-bottom-right-radius: 0.475rem">${(data.stats.bombs_exploded*100/(data.stats.bombs_planted == 0 ? 1 : data.stats.bombs_planted)).toFixed(2)}%</td>
            `;
        $(".profile-stats-table-bombs").html("").append(content);

        content = /* html */ `<tr class="position-relative cursor-pointer fs-7" style="background-color: #1b1b1b">
            <td class="ps-4 text-start" style="border-bottom-left-radius: 0.475rem">${data.stats.shots}</td>
            <td class="text-center">${data.stats.damage}</td>
            <td class="text-center">${data.stats.hits}</td>
            <td class="text-center">${data.stats.hb_head}</td>
            <td class="text-center">${parseInt(data.stats.hb_chest)+parseInt(data.stats.hb_stomach)}</td>
            <td class="text-center">${parseInt(data.stats.hb_leftarm)+parseInt(data.stats.hb_rightarm)}</td>
            <td class="text-center border border-start-0 border-top-0 border-bottom-0">${parseInt(data.stats.hb_leftleg)+parseInt(data.stats.hb_rightleg)}</td>
            <td class="text-center">${(data.stats.hits*100/(data.stats.shots == 0 ? 1 : data.stats.shots)).toFixed(2)}%</td>
            <td class="text-center">${(data.stats.damage/(data.stats.rounds == 0 ? 1 : data.stats.rounds)).toFixed(2)}</td>
            <td class="pe-4 text-end" style="border-bottom-right-radius: 0.475rem">${(data.stats.shots/(data.stats.kills == 0 ? 1 : data.stats.kills)).toFixed(2)}</td>
            `;
        $(".profile-stats-table-damage").html("").append(content);
            
        content = /* html */ `<tr class="position-relative cursor-pointer fs-7" style="background-color: #1b1b1b">
            <td class="ps-4 text-start" style="border-bottom-left-radius: 0.475rem">${data.stats.k1}</td>
            <td class="text-center">${data.stats.k2}</td>
            <td class="text-center">${data.stats.k3}</td>
            <td class="text-center">${data.stats.k4}</td>
            <td class="text-center">${data.stats.k5}</td>
            <td class="text-center">${data.stats.v1+data.stats.v2+data.stats.v3+data.stats.v4+data.stats.v5}</td>
            <td class="text-center">${data.stats.v1}</td>
            <td class="text-center">${data.stats.v2}</td>
            <td class="text-center">${data.stats.v3}</td>
            <td class="text-center">${data.stats.v4}</td>
            <td class="text-center border border-start-0 border-top-0 border-bottom-0">${data.stats.v5}</td>
            <td class="text-center">${((data.stats.v1+data.stats.v2+data.stats.v3+data.stats.v4+data.stats.v5)/(data.stats.matches == 0 ? 1 : data.stats.matches)).toFixed(2)}</td>
            <td class="pe-4 text-end" style="border-bottom-right-radius: 0.475rem">${((data.stats.k3+data.stats.k4+data.stats.k5)/(data.stats.matches == 0 ? 1 : data.stats.matches)).toFixed(2)}</td>
            `;
        $(".profile-stats-table-clutches").html("").append(content);

        content = /* html */ `<tr class="position-relative cursor-pointer fs-7" style="background-color: #1b1b1b">
            <td class="ps-4 text-start" style="border-bottom-left-radius: 0.475rem">${data.stats.first_kill}</td>
            <td class="text-center">${data.stats.first_death}</td>
            <td class="text-center">${data.stats.blind_kill}</td>
            <td class="text-center">${data.stats.flash_assist}</td>
            <td class="text-center">${data.stats.victim_flashed}</td>
            <td class="text-center">${data.stats.smoke_kill}</td>
            <td class="text-center">${data.stats.wb}</td>
            <td class="text-center">${data.stats.qs}</td>
            <td class="pe-4 text-end" style="border-bottom-right-radius: 0.475rem">${data.stats.ns}</td>
            `;
        
        $(".profile-stats-table-special").html("").append(content);

        //radar
        let element = document.getElementById("radar-stats");
        $(element).html("");
        var height = parseInt(KTUtil.css(element, 'height'));

        var color = element.getAttribute('data-kt-chart-color');
        var baseColor = KTUtil.getCssVariableValue('--bs-' + color);
        var lightColor = KTUtil.getCssVariableValue('--bs-light-' + color );
        var strokeColor = KTUtil.getCssVariableValue('--bs-' + 'gray-200');
        var labelColor = KTUtil.getCssVariableValue('--bs-' + 'gray-600');

        var bodyColor = "#1b1b1b";
        var bodybColor = "#151515";

        if ( !element ) {
            return;
        }

        let realdata = [data.stats.rating, ((data.stats.kills/(data.stats.deaths == 0 ? 1 : data.stats.deaths))).toFixed(2), (data.stats.hs*100/(data.stats.deaths == 0 ? 1 : data.stats.deaths)).toFixed(2),(data.stats.kills/(data.stats.rounds == 0 ? 1 : data.stats.rounds)).toFixed(2), (data.stats.damage/(data.stats.rounds == 0 ? 1 : data.stats.rounds)).toFixed(2)];

        let pushdata = [data.stats.rating * 100 / 2200, ((data.stats.kills*100/(data.stats.deaths == 0 ? 1 : data.stats.deaths))/2).toFixed(2), (data.stats.hs*100/(data.stats.deaths == 0 ? 1 : data.stats.deaths)).toFixed(2),(data.stats.kills/(data.stats.rounds == 0 ? 1 : data.stats.rounds)*100/2).toFixed(2), (data.stats.damage/(data.stats.rounds == 0 ? 1 : data.stats.rounds)*100/200).toFixed(2)];
        
        

        let options = {
            series: [
            {
                //name: "Series 1",
                //data: [data.stats.rating, 30, 40, 100, 20]
                data: pushdata
            }
            ],
            chart: {
                fontFamily: 'inherit',
                height: '100%',
                width: '100%',
                type: "radar",
                toolbar: {
                    show: false,
                }
            },
            
            plotOptions: {
                radar: {
                    polygons: {
                        strokeColors: "transparent",
                        connectorColors: strokeColor,
                        fill: {
                            colors: [bodybColor, bodyColor]
                        }
                    }
                }
            },
            markers: {
                colors: [lightColor],
                strokeColor: [baseColor],
                strokeWidth: 3
            },
        
            xaxis: {
                categories: ["RATING", "KDR", "HSP", "KPR", "ADR"],
                labels: {
                    show: true,
                    style: {
                        //colors: [labelColor],
                        fontSize: "13px",
                        fontFamily: 'inherit'
                    }
                },
                /*tooltip: {
                    enabled: true,
                    formatter: undefined,
                    offsetY: 0,
                    style: {
                        fontSize: '12px'
                    }
                }*/
            },
            yaxis: {   
                show: false,             
                min: 0,
                max: 100,
                tickAmount: 5,

                labels: {
                    show: false,
                },
            },

            colors: [baseColor],
        
            tooltip: {
                style: {
                    fontSize: '12px'
                },
                y: {                                        
                    title: {
                        formatter: function (value) {
                            return ""
                        }
                    },
                    formatter: function(value, b) {
                        //console.log("y:", b);
                        return realdata[b.dataPointIndex];
                    }
                },
                x: {
                    formatter: function(value, b) {
                        //console.log("x:", b)
                        return value;
                    }
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function(value, b) {
                    //console.log("y:", b);
                    return realdata[b.dataPointIndex];
                }
            },
            
            
        };

        var chart = new ApexCharts(element, options);
        chart.render();

        //winrate
        element = document.getElementById("radial-winrate");
        $(element).html("");
        //height = parseInt(KTUtil.css(element, 'height'));

        let radialoptions = {
            series: [(data.stats.matches_win*100/(data.stats.matches == 0 ? 1 : data.stats.matches)).toFixed(0)],
            chart: {
                fontFamily: 'inherit',
                height: 180,
                type: 'radialBar',
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        margin: 0,
                        size: "65%"
                    },
                    dataLabels: {
                        showOn: "always",
                        name: {
                            show: false,
                            fontWeight: '700'
                        },
                        value: {
                            color: labelColor,
                            fontSize: "24px",
                            fontWeight: '700',
                            offsetY: 8,
                            show: true,
                            formatter: function (val) {
                                return val + '%';
                            }
                        }
                    },
                    track: {
                        background: lightColor,
                        strokeWidth: '100%'
                    }
                }
            },
            colors: [baseColor],
            stroke: {
                lineCap: "round",
            },
            labels: ["Progress"]
        };

        var chart2 = new ApexCharts(element, radialoptions);
        chart2.render();

        $(".wr-win").html(data.stats.matches_win);
        $(".wr-lose").html(data.stats.matches_lose);
        $(".wr-total").html(data.stats.matches);
        $(".wr-tie").html(data.stats.matches_tie);


        //hsp
        element = document.getElementById("radial-hsp");
        $(element).html("");

        let hspoptions = {
            series: [(data.stats.hs*100/(data.stats.kills == 0 ? 1 : data.stats.kills)).toFixed(0)],
            chart: {
                fontFamily: 'inherit',
                height: 180,
                type: 'radialBar',
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        margin: 0,
                        size: "65%"
                    },
                    dataLabels: {
                        showOn: "always",
                        name: {
                            show: false,
                            fontWeight: '700'
                        },
                        value: {
                            color: labelColor,
                            fontSize: "24px",
                            fontWeight: '700',
                            offsetY: 8,
                            show: true,
                            formatter: function (val) {
                                return val + '%';
                            }
                        }
                    },
                    track: {
                        background: lightColor,
                        strokeWidth: '100%'
                    }
                }
            },
            colors: [baseColor],
            stroke: {
                lineCap: "round",
            },
            labels: ["Progress"]
        }
        
        var chart3 = new ApexCharts(element, hspoptions);
        chart3.render();

        $(".hsp-kills").html(data.stats.kills);
        $(".hsp-hs").html(data.stats.hs);
        $(".hsp-deaths").html(data.stats.deaths);

        //adr
        element = document.getElementById("radial-adr");
        $(element).html("");

        let adroptions = {
            series: [(data.stats.damage/(data.stats.rounds == 0 ? 1 : data.stats.rounds)).toFixed(1)],
            chart: {
                fontFamily: 'inherit',
                height: 180,
                type: 'radialBar',
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        margin: 0,
                        size: "65%"
                    },
                    dataLabels: {
                        showOn: "always",
                        name: {
                            show: false,
                            fontWeight: '700'
                        },
                        value: {
                            color: labelColor,
                            fontSize: "24px",
                            fontWeight: '700',
                            offsetY: 8,
                            show: true,
                            formatter: function (val) {
                                return val;
                            }
                        }
                    },
                    track: {
                        background: lightColor,
                        strokeWidth: '100%'
                    }
                }
            },
            colors: [baseColor],
            stroke: {
                lineCap: "round",
            },
            labels: ["Progress"]
        }

        var chart4 = new ApexCharts(element, adroptions);
        chart4.render();

        $(".adr-damage").html(data.stats.damage);
        $(".adr-rounds").html(data.stats.rounds);
    }

    if(tab == 'maps')
    {
        let res = await KTAPI.getPlayerMaps({steamid: data.steamid});
        //console.log(res);
        if(res.message == 'error') return;
        let pos = 1;
        let content = ``;
        res.map(mp => {
            content += `                
                <tr class="position-relative cursor-pointer match-view fs-7 bgi-no-repeat" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.0) 0px, rgb(27, 27, 27) 20rem, rgb(27, 27, 27) 80rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${mp._id}.jpg');background-color:#1b1b1b;background-position-y:center;">
                    <td class="ps-4 rounded-start h-75px">${pos}.</td>                    
                    <td class="text-center">
                        <span class="badge badge-sm badge-dark border border-primary flex-shrink-0 align-self-center text-primary fs-small" style="background-color: rgba(27,27,27,0.8)">${mp._id}</span>
                    </td>
                    <td class="text-center">${mp.wins + mp.losses + mp.draws}</td>
                    <td class="text-center">${(mp.wins*100/((mp.wins + mp.losses + mp.draws) == 0 ? 1 : mp.wins + mp.losses + mp.draws)).toFixed(2)}%</td>
                    <td class="text-center">${mp.wins}</td>
                    <td class="text-center">${mp.draws}</td>
                    <td class="text-center">${mp.losses}</td>
                    <td class="text-center">${mp.rounds}</td>
                    <td class="text-center">${(mp.rounds_win*100/(mp.rounds == 0 ? 1 : mp.rounds)).toFixed(2)}%</td>
                    <td class="text-center">${mp.rounds_win}</td>
                    <td class="text-center">${mp.rounds_lose}</td>
                    <td class="text-center">${(mp.kills/(mp.deaths == 0 ? 1 : mp.deaths)).toFixed(2)}</td>
                    <td class="text-center">${(mp.kills/(mp.rounds == 0 ? 1 : mp.rounds)).toFixed(2)}</td>                    
                    <td class="text-center">${(mp.damage/(mp.rounds == 0 ? 1 : mp.rounds)).toFixed(2)}</td>
                    <td class="text-center rounded-end pe-4">${(mp.hs*100/(mp.kills == 0 ? 1 : mp.kills)).toFixed(2)}%</td>
                </tr>
            `;
            pos++;
        });

        $(".table-maps-body").html("").append(content);

    }

    if(tab == 'weapons')
    {
        let res = await KTAPI.getPlayerWeapons({steamid: data.steamid});
        //console.log(res);
        if(res.message == 'error') return;
        let pos = 1;
        let content = ``;
        res.map(wp => {
            content += `
                <tr style="background-color: #1b1b1b" class="fs-8">
                    <td class="ps-4 rounded-start">${pos}.</td>
                    <td class="text-center" style="background: rgb(255,128,0);
                    background: radial-gradient(circle, rgba(255,128,0,0.3) 0%, rgba(255,255,255,0) 85%);">
                        <div class="d-flex flex-column">
                            <div class="text-center text-uppercase">
                                ${wp.weapon}
                            </div>
                            <div class="text-center">
                                <img src="assets/media/weapons/colored/${wp.weapon_id}.png" class="m-0" alt=""/>
                            </div>
                        </div>
                        
                    </td>
                    
                    <td class="text-center">${wp.weapon_kills}</td>
                    <td class="text-center">${wp.weapon_deaths}</td>
                    <td class="text-center">${wp.weapon_headshots}</td>
                    <td class="text-center">${(wp.weapon_headshots*100/(wp.weapon_kills == 0 ? 1 : wp.weapon_kills)).toFixed(2)}%</td>
                    <td class="text-center">${wp.weapon_fk}</td>
                    <td class="text-center">${wp.weapon_fd}</td>
                    <td class="text-center">${wp.weapon_wb}</td>
                    <td class="text-center">${wp.weapon_qs}</td>
                    <td class="text-center">${wp.weapon_ns}</td>
                    <td class="text-center">${wp.weapon_hits}</td>
                    <td class="text-center">${wp.weapon_shots}</td>
                    <td class="text-center">${wp.weapon_damage}</td>                    
                    <td class="text-center">${(wp.weapon_hits*100/(wp.weapon_shots == 0 ? 1 : wp.weapon_shots)).toFixed(2)}%</td>
                    <td class="text-center">${wp.hit_head}</td>
                    <td class="text-center">${wp.hit_chest}</td>
                    <td class="text-center">${wp.hit_stomach}</td>
                    <td class="text-center">${wp.hit_leftarm}</td>
                    <td class="text-center">${wp.hit_rightarm}</td>
                    <td class="text-center">${wp.hit_leftleg}</td>
                    <td class="text-center">${wp.hit_rightleg}</td>
                </tr>
            `
            pos++;
        });

        $(".table-weapons-body").html("").append(content);

    }

    if(tab == 'bitches')
    {        
        $(".table-bitches-body").html("").data("bitches-page",1);
        $("#profile-bitches-loader").removeClass("d-none");
        $(".table-bitches-body").data("bitches-total-results",0);
        $(".table-bitches-body").data("bitches-total-pages",0);
        $(".table-bitches-body").data("bitches-has-next",0);
        $(".table-bitches-body").data("bitches-next-page",0);

        let page = 1;
        loading = false;
        
        let res = await KTAPI.getPlayerBitches({steamid: data.steamid, paged: true, page, limit: 15});
        $(".table-bitches-body").data("bitches-total-results",res.totalDocs || 0);
        $(".table-bitches-body").data("bitches-total-pages",res.totalPages || 0);
        $(".table-bitches-body").data("bitches-has-next",res.hasNextPage || 0);
        $(".table-bitches-body").data("bitches-next-page",res.nextPage || 0);
        
        renderPlayerBitchesTable(res);
        $("#profile-bitches-loader").addClass("d-none");
    }

    if(tab == 'rating')
    {
      let res = await KTAPI.getPlayerRatingHistory({steamid: data.steamid});

      if(res.message == 'error') return;

      var rhdata = [];
      var rdata = [];
      var fixedRes = [];
      if(res.res.length)
      {
        res.res.map((match, i) => {
          let tmp = {};
          tmp.x = i+1;
          tmp.y = match.rating.toFixed(0);
          rhdata.push(tmp);
          //rdata.push(match.rating.toFixed(0));
          if(match.rating != 0)
          { 
            fixedRes.push(match);
            rdata.push(match.rating.toFixed(0));
          }
        });        
      }

      res.res = fixedRes;

      var color = 'info';
      var baseColor = KTUtil.getCssVariableValue('--bs-' + color);
      var lightColor = KTUtil.getCssVariableValue('--bs-light-' + color );
      var strokeColor = KTUtil.getCssVariableValue('--bs-' + 'gray-200');
      var labelColor = KTUtil.getCssVariableValue('--bs-' + 'gray-600');
      var borderColor = KTUtil.getCssVariableValue('--bs-' + 'gray-200');

      var bodyColor = "#1b1b1b";
      var bodybColor = "#151515";


      var options = {
        series: [{                    
          data: rdata,
        }],
        chart: {
          id: 'chartyear',            
          toolbar: {show: false,autoSelected: 'pan'},
          fontFamily: 'inherit',
          width: '100%',
          fontFamily: 'inherit',
          type: 'area',
          height: 350,
          selection: {
            enabled: false,
          },
          zoom: {
            enabled: false,
          },
          events: {            
            markerClick: function(event, chartContext, { seriesIndex, dataPointIndex, config}) {
              //window.open(`match/${res.res[dataPointIndex].matchid}`, '_blank').focus();
              router.navigate(`match/${res.res[dataPointIndex].matchid}`);
            },
            mouseMove: function(event, chartContext, config) {
              // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts.
              event.srcElement.style.cursor = 'pointer';
            }

          }
        },        
        stroke: {
          curve: 'straight',
          show: true,
          width: 3,
          colors: [baseColor]
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          type: 'solid',
          opacity: 1
        },
        yaxis: {
          //show: false,
          tickAmount: 3,
          labels: {
            style: {
                colors: labelColor,
                fontSize: '12px'
              }
          }
        },
        xaxis: {
          type: 'numeric',
          //tickAmount: 5,
          //tickPlacement: 'on',
          //min: 1,
          //decimalsInFloat: 0,
          tickPlacement: 'on',
          labels: {
            rotate: 0,
            rotateAlways: false,
            formatter: function (val) {
              return val.toFixed(0);
            }
          },
          decimalsInFloat: 0,
          axisBorder: {
            show: false,
          },
          axisTicks: {
              show: false
          },
          labels: {
              show: true,
              style: {
                  colors: labelColor,
                  fontSize: '12px'
              }
          },
          crosshairs: {
              position: 'front',
              stroke: {
                  color: baseColor,
                  width: 1,
                  dashArray: 3
              }
          },          
        },
        colors: [lightColor],
        grid: {
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true
                }
            }
        },
        tooltip: {
          enabled: true,
          style: {
            fontSize: '12px'
          },          
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            let r = getEloLevel(res.res[dataPointIndex].rating, res.res[dataPointIndex].rd);
            let dif = res.res[dataPointIndex].rating - res.res[dataPointIndex].oldrating;
            dif = dif.toFixed(2);
            dif = dif > 0 ? `+${dif}` : dif;

            return `
            <div class="d-flex flex-column align-items-center justify-content-between px-3 py-5 mw-250px">
                    <div class="text-gray-800 fs-7">Match: <span class="fs-8 fw-bold text-gray-700">${res.res[dataPointIndex].matchid}</span></div>                    
                    <div class="position-relative w-75 h-35px overflow-hidden rounded mb-2">
                      <img src="assets/media/maps/300px/${res.res[dataPointIndex].map}.jpg" class="rounded w-100" alt="" style="position: relative;top: 50%;transform: translate(-50%,-50%);left: 50%;">
                      <span class="position-absolute badge badge-sm bg-zblack bg-opacity-50 text-primary fs-small d-block fs-9" style="top: 50%;transform: translate(-50%,-50%);left: 50%;">${res.res[dataPointIndex].map}</span>
                    </div>
                    <span class="fw-bold text-gray-800 fs-7">${res.res[dataPointIndex].result == 1 ? `<span class="text-success text-nowrap"><i class="bi bi-trophy-fill me-1 text-success"></i><span>Win</span> (${dif})</span>`: (res.res[dataPointIndex].result === 0.5 ? `<span class="text-gray-500 text-nowrap"><span>Tie (${dif})</span></span>` : `<span class="text-danger text-nowrap"><span>Lose (${dif})</span></span>`)}</span> 
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-30px rounded overflow-hidden">
                            <span class="symbol-label bg-transparent">
                                <img src="assets/media/ranks/rank_${r.level}.png" class="h-100 align-self-center" alt="">
                            </span>
                        </div>                                                
                    </div>
                  </div>
                    `;
          }
        },
        markers: {
            strokeColor: baseColor,
            strokeWidth: 3,            
        },          
      };
  
      if(ratingHistoryChartA != null) ratingHistoryChartA.destroy();
      ratingHistoryChartA = new ApexCharts(document.querySelector("#chart-months"), options);
      ratingHistoryChartA.render();
        
      var optionsYears = {
        series: [{           
        data: rdata,
      }],
        chart: {
        height: 150,
        type: 'area',            
        toolbar: {
          autoSelected: 'selection',
        },
        brush: {
          enabled: true,
          target: 'chartyear'
        },
        selection: {
          enabled: true,
          xaxis: {
            //min: new Date('26 Jan 2014').getTime(),
            //max: new Date('29 Mar 2015').getTime()
            min: rdata.length ? (rdata.length > 9 ? rdata.length - 10 : 0) : 0,
            max: rdata.length
          },
          fill: {
            color: "#fff",
            opacity: 0.2
          },
        },
      },
      colors: [lightColor],
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 0,
        curve: 'smooth'
      },
      fill: {
        opacity: 1,
        type: 'solid'
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left'
      },

      grid: {
        borderColor: "#444"
      },
      markers: {
        size: 0
      },
      xaxis: {
        type: "numeric",
        min: 1,
        tickPlacement: 'on',
        //tickAmount: rdata.length-1,            
        tooltip: {
          enabled: false
        },
        labels: {
          enabled: false,
          rotate: 0,
          rotateAlways: false,
          formatter: function (val) {
            return val.toFixed(0);
          }
        },
        decimalsInFloat: 0,
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false
        },
      },
      yaxis: {
        tickAmount: 2
      }          
      
      };

      if(ratingHistoryChartB != null) ratingHistoryChartB.destroy();
      ratingHistoryChartB = new ApexCharts(document.querySelector("#chart-years"), optionsYears);
      ratingHistoryChartB.render();
        
        
      
    }
}

async function renderPlayerBitchesTable(data)
{
    let html = [];    
    if(data.message == 'error') return;
    let pos = 1;
    let res = data;
    
    data.docs.map(pl => {
        html.push(renderBitch(pl));
        pos++;
    });

    $(".table-bitches-body").append(html);
    $(".table-bitches-body").localize();
    $(".table-bitches-body").find('[data-toggle="tooltip"]').tooltip();
    await router.updatePageLinks();

    function renderBitch(data)
    {
        let t = /* html */`
            <tr class="fs-7" style="background-color:#1b1b1b;">
                <td class="ps-4 rounded-start">
                    ${(res.page-1)*(res.limit)+pos}.
                </td>
                <td class="">
                    <div class="d-flex align-items-center">
                        <!--begin::Avatar-->
                        <div class="symbol symbol-50px me-5">
                            <img src="${data.profile.avatar === undefined || data.profile.avatar == '' ? 'assets/media/avatars/default.jpg' : data.profile.avatar}" class="" alt="">
                        </div>
                        <!--end::Avatar-->                    
                        <!--begin::Text-->
                        <div class="flex-grow-1">
                            <div class="d-flex align-items-center"><img class="me-2" height="12" width="18" src="assets/media/flags/${data.profile.countrycode.toLowerCase()}.gif"/><a href="user/${data.profile.communityid}" data-navigo class="text-dark fw-bold fs-6 fnick"></a></div>
                            <a href="https://steamcommunity.com/profiles/${data.profile.communityid}/" target="_blank"><span class="text-muted d-block fw-bold">${data.profile.steamid}</span></a>
                        </div>
                        <!--end::Text-->                
                    </div>
                </td>
                <td class="text-center">${data.count}</td>
                <td class="text-center">${data.headshot}</td>
                <td class="text-center">${(data.headshot*100/(data.count == 0 ? 1 : data.count)).toFixed(2)}%</td>
                <td class="text-center">${data.killer_flashed}</td>
                <td class="text-center">${data.victim_flashed}</td>
                <td class="text-center">${data.wallbang}</td>
                <td class="text-center rounded-end pe-4">${data.smoke}</td>                
            </tr>            
        `;

        t = $(t);
        t.find(".fnick").text(data.profile.nickname);        
        return t;
    }
}



function renderPlayerFriendsTable(data){

    let html = [];    
    if(data.message == 'error') return;
    let pos = 1;
    
    data.docs.map(pl => {
        html.push(renderFriend(pl));
        pos++;
    });

    $(".profile-friends-list").append(html);
    $(".profile-friends-list").localize();
    $(".profile-friends-list").find('[data-toggle="tooltip"]').tooltip();
    router.updatePageLinks();

    function renderFriend(data)
    {
        
        let btn = ``;
        if(_user.authed == true && data.steamid != _user.me.steamid)
        {
            
            if(data.mineStatus == 0)
            {
                btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary py-2 px-4 fs-8 fs-bolder text-primary friend-add" data-commid="${data.communityid}"><i class="fad fa-user-plus"></i> <span class="">Add friend</span></button>`;
            }
            if(data.mineStatus == 1)
            {
                
                btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-info btn-active-light-info py-2 px-4 fs-8 fs-bolder text-info cursor-default friend-pending" style="cursor:default !important"><i class="fad fa-user-clock"></i> <span class="">Pending response</span></button>`;
            }
            if(data.mineStatus == 2)
            {
                btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark py-2 px-4 fs-8 fs-bolder text-dark cursor-default friend-requested"  style="cursor:default !important"><i class="fad fa-user-clock"></i> <span class="">Request sent</span></button>`;
            }
            if(data.mineStatus == 3)
            {
                btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-success btn-active-light-success py-2 px-4 fs-8 fs-bolder text-success cursor-default friend-friend" style="cursor:default !important"><i class="fad fa-user-check"></i> <span class="">Friends</span></button>`;
            }

            
            btn = $(btn);
            btn.localize();

            
        }
        if(data.stats === undefined || data.stats == null) data.stats = {rating: 0, rd: 0};
        let r = getEloLevel(data.stats.rating, data.stats.rd);
        let t = `
            <div class="col-md-4">
                <!--begin::Card-->
                <div class="card h-100">
                    <!--begin::Card body-->
                    <div class="card-body d-flex flex-center flex-column py-9 px-5">
                        <!--begin::Avatar-->
                                            <div class="symbol symbol-65px mb-5">
                                <img src="${data.avatar == '' || data.avatar === undefined ? "assets/media/avatars/blank.png" : data.avatar}" alt="image">
                                <div class="${data.connected ? 'bg-success' : 'bg-gray-400'} position-absolute rounded-circle translate-middle start-100 top-100 border border-4 border-body h-15px w-15px ms-n3 mt-n3"></div>                    </div>
                                        <!--end::Avatar-->

                        <!--begin::Name-->
                        <a href="user/${data.communityid}" data-navigo class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0 nicklink"></a>
                        <!--end::Name-->

                        <!--begin::Position-->
                        <div class="fw-semibold text-gray-400 mb-6"><a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="text-gray-400 text-hover-info">${data.steamid}</a></div>
                        <!--end::Position-->

                        <!--begin::Info-->
                        <div class="d-flex flex-center flex-wrap mb-5">
                            <!--begin::Stats-->                            
                            <div class="border border-dashed rounded py-2 px-4 mx-2 mb-3">
                                <div class="d-flex align-items-center justify-content-center">
                                    <div class="symbol symbol-45px rounded overflow-hidden">
                                        <span class="symbol-label bg-transparent">
                                            <img src="assets/media/ranks/rank_${r.level}.png" class="h-100 align-self-center" alt="">
                                        </span>
                                    </div>                                                
                                </div>
                            </div>
                            <!--end::Stats-->
                        
                            <!--begin::Stats-->
                            <div class="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3 text-center">
                                <div class="fs-6 fw-bold text-gray-800">${data.stats.rating}</div>
                                <div class="fw-semibold text-gray-400">Rating</div>
                            </div>
                            <!--end::Stats-->

                            <!--begin::Stats-->
                            <div class="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3 text-center">
                                <div class="fs-7 fw-bold text-gray-700"><img src="assets/media/flags/${data.countrycode.toLowerCase()}.gif"/> ${data.country}</div>
                                <div class="fw-semibold text-gray-400">From</div>
                            </div>
                            <!--end::Stats-->
                        </div>
                        <!--end::Info-->
                        
                        <div class="d-flex align-self-center friend-action">                            
                        </div>
                                
                        <!--begin::Indicator progress-->
                        <span class="indicator-progress">
                            Please wait...    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                        <!--end::Indicator progress-->                    
                        
                        </div>
                        <!--begin::Card body-->
                </div>
                <!--begin::Card-->
            </div>
        `;

        t = $(t);
        t.find(".nicklink").text(data.nickname);
        t.find(".friend-action").html(btn);

        return t;
    }

}


function renderPlayerMatchesTable(data)
{
    let html = [];    
    if(data.message == 'error') return;
    let pos = 1;
    
    data.docs.map(pl => {
        html.push(renderMatch(pl));
        pos++;
    });

    $(".table-matches-body").append(html);
    $(".table-matches-body").localize();
    $(".table-matches-body").find('[data-toggle="tooltip"]').tooltip();
    router.updatePageLinks();

    function renderMatch(data)
    {
        //console.log(data);
        if(data.stats === undefined || data.stats == null) return;
        let r = getEloLevel(data.stats.rating, data.stats.rd);
        //console.log("r", r);
        let t = /* html */`
            <tr data-navigo href="match/${data.matchid}" class="position-relative cursor-pointer match-view fs-7 bgi-no-repeat" matchid="${data.matchid}" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 20rem, rgb(27, 27, 27) 80rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${data.map}.jpg');background-color:#1b1b1b;">

                <td class="ps-4 rounded-start text-center"><span class="badge badge-sm badge-dark border border-primary flex-shrink-0 align-self-center text-primary fs-small" style="background-color: rgba(27,27,27,0.8)">${data.map}</span></td>
                <td><div class="d-flex justify-content-around align-items-center text-white fs-1">
                <span class="">${data.match.scoreT}</span><span class="">:</span><span class="">${data.match.scoreCT}</span>
                </div></td>
                <td><span class="badge badge-sm badge-success flex-shrink-0 align-self-center text-gray-100">PUG</span></td>
                <td><span>5v5</span></td>
                <td><span class="fw-bold text-gray-800 fs-6">${data.result == 1 ? `<span class="text-success text-nowrap"><i class="fad fa-trophy-alt top-trophy-1 me-2 text-success"></i><span>WIN</span></span>`: `<span class="text-danger text-nowrap"><span>LOSE</span></span>`}</span></td>
                <td>
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-30px me-5 rounded overflow-hidden">
                            <span class="symbol-label bg-transparent">
                                <img src="assets/media/ranks/rank_${r.level}.png" class="h-100 align-self-center" alt="">
                            </span>
                        </div>                                                
                    </div>
                </td>
                <td>${data.stats.rating}</td>
                <td>${data.stats.kills}</td>
                <td>${data.stats.deaths}</td>
                <td>${data.stats.assists}</td>
                <td>${(data.stats.kills/(data.stats.deaths == 0 ? 1 : data.stats.deaths)).toFixed(2)}</td>
                <td>${(data.stats.damage/(data.stats.rounds == 0 ? 1 : data.stats.rounds)).toFixed(2)}</td>
                <td>${(data.stats.hs*100/(data.stats.kills == 0 ? 1 : data.stats.kills)).toFixed(2)}%</td>
                <td>${data.stats["v1"]}</td>
                <td>${data.stats["v2"]}</td>
                <td>${data.stats["v3"]}</td>
                <td>${data.stats["v4"]}</td>
                <td>${data.stats["v5"]}</td>
                <td>${data.stats["k3"]}</td>
                <td>${data.stats["k4"]}</td>
                <td class="pe-4 rounded-end">${data.stats["k5"]}</td>                                
                
            </tr>            
        `;

        t = $(t);
        

        return t;
    }
}

$(document).ready(function(){    
    
    $(window).scroll(async function() {
        if(router.getCurrentLocation().url.includes("user"))
        {
            if($(".profile-tab-content .tab-pane.main-tab.fade.show.active").attr("id") == "profile-tab-matches" && $(".table-matches-body").data("matches-has-next") == true)
            {      
                console.log(loading);
                if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                    loading = true;
                    $("#profile-matches-loader").removeClass("d-none");
                    console.log(tempdata.steamid,$(".table-matches-body").data("players-next-page"));
                    let res = await KTAPI.getPlayerMatches({steamid: tempdata.steamid, paged: true, page: $(".table-matches-body").data("matches-next-page"), limit: 15});
                    
                    
                    $(".table-matches-body").data("matches-page",res.page);
                    $(".table-matches-body").data("matches-has-next",res.hasNextPage);
                    $(".table-matches-body").data("matches-next-page",res.nextPage);
                    
                    renderPlayerMatchesTable(res);
                    loading = false;
                    $("#profile-matches-loader").addClass("d-none");
                }
            }
            if($(".profile-tab-content .tab-pane.main-tab.fade.show.active").attr("id") == "profile-tab-friends" && $(".profile-friends-list").data("friends-has-next") == true)
            {
                if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                    loading = true;
                    $("#profile-friends-loader").removeClass("d-none");                    

                    let res = await KTAPI.getFriendsWithStats({id: tempdata.communityid, paged: true, page: $(".profile-friends-list").data("friends-next-page"), limit: 10, requester: !_user.authed ? '' : _user.me._id});
                                        
                    $(".profile-friends-list").data("friends-page",res.page);
                    $(".profile-friends-list").data("friends-has-next",res.hasNextPage);
                    $(".profile-friends-list").data("friends-next-page",res.nextPage);                    
                    renderPlayerFriendsTable(res);
                    loading = false;
                    $("#profile-friends-loader").addClass("d-none");
                }
            }

            if($(".profile-tab-content .tab-pane.main-tab.fade.show.active").attr("id") == "profile-tab-statistics" && $(".profile-statistics-tab-content .tab-pane.fade.show.active").attr("id") == "profile-statistics-tab-bitches" && $(".table-bitches-body").data("bitches-has-next") == true)
            {
                if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                    loading = true;
                    $("#profile-bitches-loader").removeClass("d-none");                    

                    let res = await KTAPI.getPlayerBitches({steamid: tempdata.steamid, paged: true, page: $(".table-bitches-body").data("bitches-next-page"), limit: 15});
                                        
                    $(".table-bitches-body").data("bitches-page",res.page);
                    $(".table-bitches-body").data("bitches-has-next",res.hasNextPage);
                    $(".table-bitches-body").data("bitches-next-page",res.nextPage);                    
                    renderPlayerBitchesTable(res);
                    loading = false;
                    $("#profile-bitches-loader").addClass("d-none");
                }
            }
        }
    });

    $(document).on("click", ".match-go", function(e) {
        let prof = `match/${$(this).attr("matchid")}`;
        router.navigate(prof);
    });
    
});


const getEloLevel = (rate, rd) => {
    if(rd == 100) return {level: 0, prev: 0, next:800};
    if(rate >= 0 && rate < 801)
    {
        return {level: 1, prev: 0, next:800};
    }
    if(rate > 800 && rate < 951)
    {
        return {level: 2, prev: 800, next:950};
    }
    if(rate > 950 && rate < 1101)
    {
        return {level: 3, prev: 950, next:1100};
    }
    if(rate > 1100 && rate < 1251)
    {
        return {level: 4, prev: 1100, next:1250};
    }
    if(rate > 1250 && rate < 1401)
    {
        return {level: 5, prev: 1250, next:1400};
    }
    if(rate > 1400 && rate < 1551)
    {
        return {level: 6, prev: 1400, next:1550};
    }
    if(rate > 1550 && rate < 1701)
    {
        return {level: 7, prev: 1550, next:1700};
    }
    if(rate > 1700 && rate < 1851)
    {
        return {level: 8, prev: 1700, next:1850};
    }
    if(rate > 1850 && rate < 2001)
    {
        return {level: 9, prev: 1850, next:2000};
    }
    if(rate > 2000)
    {
        return {level: 10, prev: 2000, next:2000};
    }
};

export { getEloLevel };
export default user;